export class Api {
    protected URL = 'https://api.elixiroom.ru'
}